define('GameDayCore/GDModel/ValueObjects/Bench/BenchFile',['require','exports','module','../ValueObjectFactory','extant/extant','./BenchBatter','./BenchPitcher'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant");

	VO.create(BenchFile, {
		getPlayerByID: function(ID, $b_or_p) {
			var players = [],
				b_or_p = (exists($b_or_p)) ? $b_or_p.toLowerCase() : "n/a";

			if (b_or_p.toLowerCase() === "b") {
				players = players.concat(away.batters, home.batters);
			}
			else if (b_or_p === "p") {
				players = players.concat(away.pitchers, home.pitchers);
			} else {
				players = players.concat(away.batters, away.pitchers, home.batters, home.pitchers);
			}

			for (var i = 0, long = players.length; i < long; i++) {
				if (players[i].id === ID.toString()) { return players[i]; }
			}

			return null;
		}
	});

	function BenchFile($data) {
		var vo = VO.ensureVO(this, BenchFile),
			data = $data,
			away = {
				team: (exists(data.away.tid)) ? data.away.tid : "",

				batters: (exists(data, "away.batters.batter")) ? parseBatters(data.away.batters.batter, data.away.tid) : [],
				pitchers: (exists(data, "away.pitchers.pitcher")) ? parsePitchers(data.away.pitchers.pitcher, data.away.tid) : []
			},
			home =  {
				team: (exists(data.home.tid)) ? data.home.tid : "",

				batters: (exists(data, "home.batters.batter")) ? parseBatters(data.home.batters.batter, data.home.tid) : [],
				pitchers: (exists(data, "home.pitchers.pitcher")) ? parsePitchers(data.home.pitchers.pitcher, data.home.tid) : []
			}

		vo.away = away;
		vo.home = home;
		vo.away_batters = away.batters;
		vo.away_pitchers = away.pitchers;
		vo.home_batters = home.batters;
		vo.home_pitchers = home.pitchers;
	}

	function parseBatters(players, team) {
		var batters = [],
			BenchBatter = require("./BenchBatter");

		for (var i = 0, long = players.length; i < long; i++) {
			batters[i] = new BenchBatter(players[i], team);
		}

		return batters;
	}

	function parsePitchers(players, team) {
		var pitchers = [],
			BenchPitcher = require("./BenchPitcher");

		for (var i = 0, long = players.length; i < long; i++) {
			pitchers[i] = new BenchPitcher(players[i], team);
		}

		return pitchers;
	}

	return BenchFile;
});
